import { createMuiTheme } from '@material-ui/core/styles';
import blue from '@material-ui/core/colors/lightBlue';

const theme = createMuiTheme({

    palette: {
        primary: blue//{ main: "#2699FB" }
    },
    typography: {
        fontFamily: [
          '"Open Sans"',
          'Roboto',
          '"Helvetica Neue"',
          'Arial',
          'sans-serif'
        ].join(','),
      }

})

export default theme;